import {NativeEventEmitter, NativeModules} from 'react-native';

import {BarcodesFile} from '@buncha/config/graphQL/type';

interface NativeModulesStatic {
  DeviceScanner: {
    isBluetoothEnabled(callback: (isEnabled: boolean) => void): void;
    enableBluetooth(): void;
    disableBluetooth(): void;
    enableScan(): Promise<any>;
    disableScan(): void;
    pairToDevice(deviceAddress: string): Promise<any>;
    scanBLeDevice(): Promise<any>;
  };
  RNPrinter: {
    ScanDevice: (searchTime: number) => Promise<any>;
    PrintLabel: (
      labelData: BarcodesFile,
      bleDeviceAddress: String,
    ) => Promise<any>;
  };
}

const nativeModule = {
  DeviceScanner: NativeModules.DeviceScanner,
  RNPrinter: NativeModules.RNPrinter,
};

export const PrinterNativeModule: NativeModulesStatic = nativeModule;
export const DeviceScannerEmitter = new NativeEventEmitter(
  nativeModule.DeviceScanner,
);
